/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Save_Settings_LabelInputs */

const en_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save general settings`)
};

const fr_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres généraux`)
};

const de_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Einstellungen speichern`)
};

const it_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le impostazioni generali`)
};

const ru_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните общие настройки`)
};

const es_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar configuración general`)
};

const zh_cn2_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存常规设置`)
};

const ja_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般設定を保存する`)
};

const hi_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य सेटिंग्स सहेजें`)
};

const pt_pt2_options_general_save_settings_label = /** @type {(inputs: Options_General_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar configurações gerais`)
};

/**
* | output |
* | --- |
* | "Save general settings" |
*
* @param {Options_General_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_save_settings_label = /** @type {((inputs?: Options_General_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_save_settings_label(inputs)
	if (locale === "de") return de_options_general_save_settings_label(inputs)
	if (locale === "it") return it_options_general_save_settings_label(inputs)
	if (locale === "ru") return ru_options_general_save_settings_label(inputs)
	if (locale === "es") return es_options_general_save_settings_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_save_settings_label(inputs)
	if (locale === "ja") return ja_options_general_save_settings_label(inputs)
	if (locale === "hi") return hi_options_general_save_settings_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_save_settings_label(inputs)
	return en_options_general_save_settings_label(inputs)
});